/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {BookmarksWidgetEl} from 'common/widgets/bookmarks-widget';

import {CodeTipEl} from '../components/code-tip';
import type {DesignSystem} from '../index';
import {Section, SubSection} from './utils';

export function BookmarksWidgetSection({designSystem}: {designSystem: DesignSystem}) {
  return (
    <Section title='Bookmarks Widget'>
      <SubSection title='mp-bookmarks-widget' autoDoc={true}>
        <p sel='.desc'>A drop menu that accomodates search, browse, removal, and creation of bookmarked reports.</p>

        <CodeTipEl sel='.example'>
          <BookmarksWidgetEl
            attrs={{
              bookmarks: designSystem.state.bookmarks,
              'create-disabled': false,
              saving: designSystem.state.savingBookmark,
              'selected-bookmark-id': designSystem.state.selectedBookmarkId,
              'user-id': 1,
              'has-write-permissions': true,
            }}
            on={{
              change: designSystem.helpers.handleBookmarksMenuChange,
              submit: designSystem.helpers.handleBookmarksMenuSubmit,
            }}
          />
        </CodeTipEl>
      </SubSection>
    </Section>
  );
}
